import { serverSideGetShopAvailQuery } from '../../generated/react-query';
import type { QueryClient } from '@tanstack/react-query';
import type { ShopSpecialRateInput } from '@dx-ui/gql-types';

export const spaRequest = async (
  language: string,
  ctyhocn: string,
  arrivalDate: string,
  departureDate: string,
  numAdults: number,
  specialRates: ShopSpecialRateInput,
  client: QueryClient,
  guestLocationCountry: string | undefined
) => {
  try {
    const spaResult = await serverSideGetShopAvailQuery(client, {
      language,
      ctyhocn,
      arrivalDate,
      departureDate,
      numAdults,
      specialRates,
      guestLocationCountry,
    });
    return spaResult;
  } catch (error) {
    // return gql related error
    throw new Error(JSON.stringify(error));
  }
};
